
import React from 'react'; // live

import { StrictMode } from 'react'; // dev

import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import store from './state/store';
import { Provider } from 'react-redux';
import { GoogleOAuthProvider } from '@react-oauth/google';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
	
	// remove the StrictMode tag when going live - Becaue it checks bugs in development and run everything twice
	<StrictMode>
    <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
      <Provider store = {store}>
        <App />
      </Provider>
    </GoogleOAuthProvider>
	</StrictMode>
  
  /*
  <React.StrictMode>
   <Provider store = {store}>
        <App />
    </Provider>,
  </React.StrictMode>
  */
);

